<template>
    <v-container grid-list-md fluid v-if="options.length">
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters class="d-flex align-center">
                    <v-col cols="1" class="d-flex justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11">
                        <h2>
                            {{ title }}
                        </h2>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <v-btn
                        v-if="options.length && options[2].value === true"
                        :disabled="closedPeriod || validated"
                        @click="
                            createRows();
                            miscellaneousOperationDialog = true;
                        "
                        size="small"
                    >
                        OD
                    </v-btn>

                    <v-tooltip location="bottom" :text="documentManagerTooltip">
                        <template v-slot:activator="{ props }">
                            <div v-bind="props">
                                <v-btn
                                    @click="dialogAuditCheckDocumentsManager = true"
                                    size="x-small"
                                    icon="$oss-upload"
                                    class="mx-1"
                                    :disabled="!auditCheckResultId"
                                />
                            </div>
                        </template>
                    </v-tooltip>

                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="upsertAuditCheckResult()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="
                            formValid || closedPeriod || loading || dataLoading || !accountingPeriod
                        "
                        @click="validateFunction()"
                        data-cy="AuditCheckManual-valid"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                upsertAuditCheckResult('REVIEW');
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                upsertAuditCheckResult('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>

                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>

                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>

                            <template v-if="!showDeleteAcrBtnIfRecovery">
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <div no-gutters v-bind="props">
                                            <v-list-item no-gutters disabled>
                                                <v-list-item-title>
                                                    Supprimer le contrôle
                                                </v-list-item-title>

                                                <template v-slot:append>
                                                    <v-icon size="small"> $oss-trash </v-icon>
                                                </template>
                                            </v-list-item>
                                        </div>
                                    </template>
                                    <span>{{ showDeleteAcrBtnTooltipMessage }}</span>
                                </v-tooltip>
                            </template>

                            <template v-else>
                                <v-list-item
                                    no-gutters
                                    @click="deleteAuditCheckResultDialog = true"
                                >
                                    <v-list-item-title> Supprimer le contrôle </v-list-item-title>

                                    <template v-slot:append>
                                        <v-icon>$oss-trash</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <!-- // * loading -->
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <template v-else>
                <v-row
                    no-gutters
                    v-if="accountingPeriod && accountingPeriod.closed"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>

                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-8"
                    v-if="acKey === '3Nai3ztgXhvmIS5wnQHnY1T'"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Données du dossier</h5>
                            </v-card-title>
                        </v-col>
                        <v-spacer />
                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" />
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            showCompanyEdition
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="showCompanyEdition = !showCompanyEdition"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-card-text v-show="showCompanyEdition">
                        <v-row>
                            <!-- // ** title ************** -->
                            <v-col cols="12">
                                <CompanyEdition :mode="'auditReport'"> </CompanyEdition>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** Form -->
                <DeclarationForm
                    v-if="!dataLoading"
                    v-model="form"
                    :auditForm="form"
                    :auditCheckResult="fields"
                    :hide-header="true"
                    :readonly="validated || closedPeriod"
                    ref="taxForm"
                    @validUpdate="updateFormValid($event)"
                >
                </DeclarationForm>

                <!-- // ** accountableAccounts -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                    v-if="accountableAccounts.length"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <v-row no-gutters class="d-flex align-center">
                                    <v-col cols="2">
                                        <h5 v-if="accountableAccounts.length" class="pl-4">
                                            Extrait du grand livre
                                        </h5>
                                    </v-col>
                                    <v-spacer />
                                    <v-col cols="4">
                                        <v-select-filled
                                            v-model="glAccountingPeriod"
                                            :items="accountingPeriodsList"
                                            label="Exercice"
                                            :disabled="
                                                !generalLedgerExpand ||
                                                !accountingPeriodsList.length ||
                                                accountingPeriodsList.length === 1
                                            "
                                            hide-details
                                            inset
                                            outlined
                                            density="compact"
                                            item-title="text"
                                        />
                                    </v-col>
                                    <v-spacer />
                                    <v-col cols="4">
                                        <v-combobox-filled
                                            v-model="glAccountableAccountsRoot"
                                            label="Racines comptes"
                                            multiple
                                            outlined
                                            hide-details
                                            dense
                                            chips
                                            deletable-chips
                                            item-disabled
                                            :disabled="
                                                !generalLedgerExpand ||
                                                !accountingPeriodsList.length ||
                                                accountingPeriodsList.length === 1
                                            "
                                            clearable
                                        />
                                    </v-col>
                                    <v-spacer />
                                    <v-col cols="1">
                                        <v-switch
                                            v-model="showNm1"
                                            label="N-1"
                                            hide-details
                                            :disabled="
                                                !generalLedgerExpand ||
                                                !accountingPeriodsList.length ||
                                                accountingPeriodsList.length === 1
                                            "
                                            class="pl-2 mt-0"
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" />
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand = !generalLedgerExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-card-text
                        v-show="generalLedgerExpand"
                        transition="expand"
                        style="padding-bottom: 150px"
                    >
                        <v-row>
                            <v-col cols="12">
                                <GeneralLedger
                                    ref="generalLedger"
                                    :companyId="companyId"
                                    :accountingPeriodId="glAccountingPeriod"
                                    :accountableAccountFilter="glAccountableAccountsRoot"
                                    :hideOptions="hideOptions"
                                    :inThirdParty="showThirdParty"
                                    @thirdPartyChanged="showThirdParty = !showThirdParty"
                                    :inNm1="showNm1"
                                    @nm1Changed="showNm1 = !showNm1"
                                    @query-done="fetchTotals"
                                    :enableAuditedAccountableAccounts="
                                        glAccountingPeriod === accountingPeriodId
                                    "
                                >
                                </GeneralLedger>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** Documents -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ** longComments -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                    v-if="options.length && options[1]?.value === true"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" />
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        @click="commentExpand = !commentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text
                        v-if="commentExpand"
                        transition="expand"
                        style="padding-bottom: 150px"
                    >
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-textarea
                                    v-model="comment"
                                    :disabled="closedPeriod || validated"
                                    auto-grow
                                    style="height: auto; border: 1px #ededed solid"
                                    outlined
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** shortComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                    v-if="options.length && options[0]?.value === true"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" />
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text
                        v-if="shortCommentExpand"
                        transition="expand"
                        style="padding-bottom: 150px"
                    >
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-textarea
                                    v-model="shortComment"
                                    :disabled="closedPeriod || validated"
                                    auto-grow
                                    style="height: auto; border: 1px #ededed solid"
                                    outlined
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <!-- <AccountingItemEdition
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                    v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition> -->
                <oss-dialog
                    v-model="miscellaneousOperationDialog"
                    :actions="actionsMiscellaneousOperation"
                    min-width="90vw"
                >
                    <AccountingItemEdition2
                        v-if="miscellaneousOperationDialog"
                        :companyId="companyId"
                        :prefilledRows="miscellanousOperationData"
                        :acKey="acKey"
                        :actions="actionsMiscellaneousOperation"
                        :auditCheckResult="auditCheckResult"
                        :accountingPeriodId="accountingPeriodId"
                        @upsert="onOdUpserted($event)"
                    />
                </oss-dialog>

                <!-- ++ deleteAuditCheckResultDialog -->
                <template v-if="deleteAuditCheckResultDialog">
                    <AuditDeleteAuditCheckResultDialog
                        v-model="deleteAuditCheckResultDialog"
                        :auditCheckResultId="auditCheckResultId"
                        @closed="
                            deleteAuditCheckResultLoading = false;
                            deleteAuditCheckResultDialog = false;
                        "
                        @deletedAcr="deleteAcrDone"
                    />
                    <!-- deleteAuditCheckResultLoading="deleteAuditCheckResultLoading" -->
                </template>

                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";

import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import Chat from "../chat/Chat.vue";
import { CheckBase } from "./CheckBase";
import DeclarationFormComp, { DeclarationForm } from "../taxForm/declaration/DeclarationForm.vue";
import GeneralLedger from "../GeneralLedger2.vue";
import Document from "../document/DocumentRouter.vue";
import CompanyEdition from "../admin/CompanyEdition.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import AuditDeleteAuditCheckResultDialog from "./AuditDeleteAuditCheckResultDialog.vue";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import { getDBFormattedDate } from "@/services/dateServices";
import { DialogAction } from "@/services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Ref } from "vue-facing-decorator";

@Component({
    components: {
        DeclarationForm: DeclarationFormComp,
        GeneralLedger,
        Document,
        CompanyEdition,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        AuditDeleteAuditCheckResultDialog,
        AccountingItemEdition2,
    },
})
export class AuditCheckManual extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) pathName: string;
    @Prop({ default: null }) audit: any;

    @Ref("taxForm") taxForm: DeclarationForm;

    loading: boolean = false;
    dataLoading: boolean = true;
    deleteAuditCheckResultLoading: boolean = false;

    // withAccountingPeriod: boolean = false;

    // accountingPeriodEnd: string = ""

    auditCheckResult: any = null;
    validated: boolean = false;
    comment: string = "";
    shortComment: string = "";

    miscellanousOperationData: Array<any> = [];

    commentExpand: boolean = false;
    shortCommentExpand: boolean = false;
    documentsExpand: boolean = false;

    miscellaneousOperationDialog: boolean = false;
    deleteAuditCheckResultDialog: boolean = false;

    dialogAuditCheckDocumentsManager: boolean = false;

    showCompanyEdition: boolean = false;
    showDeleteAcrBtnTooltipMessage: string = "";

    noResults: boolean = false;
    generalLedgerExpand: boolean = false;

    title: string = "";

    form: any = null;
    formValid: boolean = false;

    options: Array<any> = [];
    showThirdParty: boolean = true;

    hideOptions: boolean = true;

    documents: Array<any> = [];
    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    alreadyLinkedDoc: boolean = false;

    // get selectedCompany() {
    //     return this.$store.getters.getCompany(this.companyId);
    // }

    accountingTransactions: Array<any> = [];
    withoutLettering: boolean = false;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    get documentManagerTooltip() {
        if (this.auditCheckResultId) {
            return "Lier un document";
        }
        return "Enregistrez le contrôle une première fois pour pouvoir lier un document";
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    // key: string = ""

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
        window.scrollTo(0, 0);
    }

    updateFormValid(data) {
        this.formValid = !data;
    }

    // afterAccountingPeriodFound() {
    // }

    // ++++++++++++++++++ ACCOUNTING LINES and AUDIT CHECK RESULT +++++++++++++
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            this.dataLoading = true;
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId || undefined,
            };
        },
        skip() {
            return !this.accountingPeriodId || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                if (data.auditItems && data.auditItems.items && data.auditItems.items[0]) {
                    this.auditItems = JSON.parse(JSON.stringify(data.auditItems.items[0]));

                    if (this.auditItems.auditCheckResult?.[0]?.id) {
                        this.auditCheckResult = this.auditItems.auditCheckResult[0];

                        this.auditCheckResultId = this.auditCheckResult.id;
                        const aaData = this.auditCheckResult.data[0];
                        if (aaData) {
                            this.comment = aaData.comment || "";
                            this.shortComment = aaData.shortComment || "";
                            this.validated = aaData.validated || false;
                            this.fields = aaData.form || null;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }

                        if (this.auditCheckResult.documents) {
                            this.connectedDocuments = this.auditCheckResult.documents;
                        }

                        if (this.auditCheckResult.results) {
                            this.results = this.auditCheckResult.results;
                        }
                    } else {
                        this.auditCheckResultId = "";
                        this.comment = "";
                        this.shortComment = "";
                        this.validated = false;
                        this.fields = null;
                    }

                    // ** GeneralLedger - accountableAccounts
                    if (
                        this.auditItems.accountableAccounts &&
                        this.auditItems.accountableAccounts.length
                    ) {
                        this.accountableAccounts = this.auditItems.accountableAccounts;
                        this.accountableAccountsRoot =
                            this.auditItems.accountableAccountsRoot || undefined;

                        const accountableAccountsRoot4 = this.accountableAccounts.filter(
                            (aar) => aar.name.startsWith("40") || aar.name.startsWith("41"),
                        );

                        if (!accountableAccountsRoot4.length) {
                            this.showThirdParty = false;
                            this.hideOptions = true;
                        } else if (
                            accountableAccountsRoot4.length === this.accountableAccounts.length
                        ) {
                            this.showThirdParty = true;
                            this.hideOptions = true;
                        } else {
                            this.showThirdParty = true;
                            this.hideOptions = false;
                        }
                    }

                    if (this.auditItems && this.auditItems.data && this.auditItems.data.form) {
                        this.form = this.auditItems.data.form;
                    }

                    if (this.auditItems && this.auditItems.data && this.auditItems.data.options) {
                        this.options = this.auditItems.data.options;
                    }

                    if (this.auditItems && this.auditItems.title) {
                        this.title = this.auditItems.title;
                    }
                }
                this.dataLoading = false;
                // } else {
                // this.initialiseCompany()
            }
        },
    })
    auditItems: any;

    accountableAccounts: any = [];

    reviewed: number = 0;

    fields: any = null;

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    async fetchTotals(detailledBalanceInfos) {
        if (this.accountableAccounts.length) {
            if (detailledBalanceInfos.aaName) {
                const foundedAA = this.accountableAccounts.find(
                    (aa) => aa.name === detailledBalanceInfos.aaName,
                );
                if (foundedAA) {
                    const indexFoundedAA = this.accountableAccounts.indexOf(foundedAA);

                    this.accountableAccounts[indexFoundedAA].queryLength =
                        detailledBalanceInfos.queryLength;

                    this.accountableAccounts[indexFoundedAA].aaName = detailledBalanceInfos.aaName;

                    this.accountableAccounts[indexFoundedAA].totalBalance =
                        detailledBalanceInfos.totalBalance;

                    this.accountableAccounts[indexFoundedAA].totalCredit =
                        detailledBalanceInfos.totalCredit;

                    this.accountableAccounts[indexFoundedAA].totalDebit =
                        detailledBalanceInfos.totalDebit;
                }

                const allFetchsDone = this.accountableAccounts.every((accAccount: any) =>
                    Object.hasOwn(accAccount, "queryLength"),
                );

                if (allFetchsDone) {
                    // *** if any lines received
                    const noQueryLengths = !this.accountableAccounts.some(
                        (accAccount) => accAccount.queryLength > 0,
                    );
                    if (noQueryLengths) {
                        this.noResults = true;
                    } else if (!this.auditCheckResultId) {
                        this.upsertAuditCheckResult();
                    }
                }
            }
        } else {
            debugger; // git-ignore
        }
    }

    // ++++++++++++++ UPSERT +++++++++++++++
    async upsertAuditCheckResult(action = undefined, results = undefined) {
        const acrData = [
            {
                comment: this.comment || "",
                shortComment: this.shortComment || "",
                validated: this.validated || false,
                form: this.taxForm.saveAuditForm(),
                count: this.form.length,
            },
        ];

        const connectOdsToResults = this.results.map(({ id }) => ({ id }));
        if (results?.output?.documents?.[0]) {
            connectOdsToResults.push({ id: results.output.documents[0] });
        }

        if (this.acKey && this.companyId && this.accountingPeriodId) {
            const auditCheckResultVariables = {
                id: this.auditCheckResultId || "",
                key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                status: this.validated ? "VALIDATED" : "EDITION",
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                data: JSON.parse(JSON.stringify(acrData)) || undefined,
                // connectDocuments: connectedDocumentIds || undefined,
                connectOdsToResults: connectOdsToResults.length ? connectOdsToResults : undefined,
                auditCheckKey: this.acKey,
                // deleteDocuments: [], // ** previous results, if to delete
                // documents: [],  // ** results = générés par le contrôle
                connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
                type: "IN_AUDIT_REPORT",
                reviewed: this.reviewed,
            };

            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT,
                variables: auditCheckResultVariables,
            });

            // await this.createUserActivity(action) // deprecated

            // ++++++++++++++ REFRESH +++++++++++++++++++
            this.refresh();
        } else {
            debugger;
        }
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            if (this.generalLedger) {
                await this.generalLedger.setAllAccountableAccountsAsAudited();
            }
            await this.upsertAuditCheckResult("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            if (this.generalLedger) {
                await this.generalLedger.setAllAccountableAccountsAsUnaudited();
            }
            await this.upsertAuditCheckResult("UPDATE");
        }
    }

    async onOdUpserted(results) {
        await this.upsertAuditCheckResult(undefined, results);
        this.miscellaneousOperationDialog = false;
    }

    refresh() {
        // ++ pass through after $emit upsertedAuditCheckResult in Manager
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            debugger; // git-ignore
        }

        // this.initialiseCompany()
    }

    upsertedACR() {
        this.refresh();
    }

    createRows() {
        this.miscellanousOperationData = [];

        const date = getDBFormattedDate(this.accountingPeriod.end) || getDBFormattedDate(moment());

        const row = {
            date: date,
            accountableAccount: { name: "" },
            wording: "Régul du " + this.formatDate(date),
            netAmount: 0.0,
            debit: 0.0,
            credit: 0.0,
        };

        this.miscellanousOperationData.push(row, row);
    }

    aaExpand(accountableAccount) {
        accountableAccount.expand = !accountableAccount.expand;
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    // addNewDocument(data) {
    //     this.connectedDocuments.push(data)
    // }

    // validateNewDocuments(data) {
    //     this.upsertAuditCheckResult()
    // }

    // replaceList(data) {
    //     this.connectedDocuments = data
    //     this.upsertAuditCheckResult()
    // }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }

    get showDeleteAcrBtnIfRecovery() {
        if (this.auditCheckResult?.id) {
            if (this.closedPeriod) {
                this.showDeleteAcrBtnTooltipMessage = "Exercice N clôturé";
                return false;
            }
            return true;
        }
        this.showDeleteAcrBtnTooltipMessage = "Aucun contrôle";
        return false;
    }

    deleteAcrDone() {
        this.deleteAuditCheckResultLoading = false;
        this.deleteAuditCheckResultDialog = false;
        this.refresh();
    }
}

export default toNative(AuditCheckManual);
</script>
